module.exports = __webpack_public_path__ + "static/img/8.4d3d179.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/modules/mobile/assets/images/partners/pinterest/8.jpeg
// module id = XW7m
// module chunks = 46